import type { Prototype } from "../prototype-types";

export const laurenBlakePrototypes: Prototype[] = [
  {
    id: "brand-funded-promo-modal-exploration",
    name: "Brand-Funded Promo Modal Exploration",
    path: "/lb/brand-funded-promo-modal-exploration",
    description:
      "Exploring disclaimer modal treatments for brand-funded promotions across brand pages and PDPs.",
    owner: "Lauren Blake",
    createdAt: "2026-04-03",
    lastUpdated: "2026-04-03",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/a1f9fdb4e3a760e2ae1d7ad9575a2ddeb7ba4493b5960a2e8bf13928db4c9404.png",
    creationTool: "cursor",
  },
  {
    id: "abandoned-cart-automation-setup",
    name: "Abandoned Cart Automation Setup",
    path: "/lb/abandoned-cart-automation-setup",
    description:
      "Brands set up a new automation template for open cart automations and configure a personalized discount for the retailer. Uses the existing automations list and composer, part of automation setup flows (brand-portal/marketing/reminders).",
    owner: "Lauren Blake",
    createdAt: "2026-03-05",
    lastUpdated: "2026-04-01",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/d510d0aab55e0d358917b38489f29dcd2eb42fd11be045eea5cf71b8c7cf5211.png",
    creationTool: "claude-code",
  },
];
